import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { Form, FormikProvider, useFormik } from "formik";

import RebatesClient from "../../RebatesClient";

import { FormikTextField, Icon } from "../../components";
import { CustomButton } from "../../components/custom-button/custom-button";

import { paddingXY } from "../../emotion/utils";

import css from "./login.module.css";

const ForgotPasswordForm = (props) => {
	const navigate = useNavigate();
	const { setOpen } = props;

	const [hasError, setHasError] = useState(false);

	const handlePasswordReset = async () => {
		try {
			let email = document.getElementById("email").value;

			if (!email.length) {
				return;
			}

			const response = await RebatesClient.forgotPassword(email);
			const status = response["response"]["status"];

			if (status > 299) {
				throw new Error(
					"Error occured trying to send password reset email, the email was not sent"
				);
			} else {
				alert(
					"Please check your email for a link to reset your password."
				);
				navigate("/");
			}
		} catch (err) {
			console.log(err);
			alert(
				"Error occured trying to send password reset email, the email was not sent"
			);
		}
	};

	const validationSchema = Yup.object({
		email: Yup.string().label("Email").required("Email is required"),
	});

	const formik = useFormik({
		initialValues: {
			email: "",
		},
		validationSchema: validationSchema,
		onSubmit: async (values) => {
			const email = values["email"];

			const response = await RebatesClient.forgotPassword(email);
			const status = response["response"]["status"];

			if (status > 299) {
				throw new Error(
					"Error occured trying to send password reset email, the email was not sent"
				);
			} else {
				alert(
					"Please check your email for a link to reset your password."
				);
				navigate("/");
			}

			// // const ret = await RebatesClient.login(username, password);
			// // if (!ret.ok) {
			// // 	setHasError(true);
			// // 	setIsLoggedIn(false);
			// // }

			// const response = ret.body;
			// setIsLoggedIn(true);
			// saveUserData(response);
			// navigate("/");
		},
	});

	return (
		<FormikProvider value={formik}>
			<Form className={css.form}>
				<Icon icon="ValleyLogo" />

				<div className={css.fieldset}>
					<div className={css.intro}>
						<div className={css.title}>Forgot your password?</div>
						<div className={css.subtitle}>
							You can reset it here!
						</div>
					</div>

					<div className={css.fields}>
						<FormikTextField
							label="Email"
							labelShrink={true}
							name="email"
							type="email"
						/>

						<CustomButton
							label="Reset password"
							type="submit"
							style={{
								marginTop: 20,
								width: "100%",
							}}
						/>

						<CustomButton
							label="Back to login"
							type="link"
							onClick={(e) => {
								setHasError(false);
								setOpen(false);
								e.preventDefault();
							}}
							style={{
								...paddingXY(0),
								border: 0,
								boxShadow: "none",
								margin: "0 auto",
							}}
						/>
					</div>
				</div>
			</Form>
		</FormikProvider>
	);
};

export default ForgotPasswordForm;
